module.exports = __webpack_public_path__ + "286497c81536e6343e941b6574e5845d.png";